import Image from '@/shared/ui/AppImage'
import { AppIcon  } from '@/shared/ui/icons'

import { StarIcon } from '@hugeicons/react'
import _ from 'lodash'

import { truncateName } from '@/shared/lib/string/truncate-name'
import { Avatar } from '@/shared/ui/Avatar'

export const DigitalProductLandingPagesRankingUserWidget = ({
  rank,
  user_progress,
  whiteRanking = false,
  points,
  size = 'lg',
  className = '',
  ...rest
}) => {
  const user = user_progress?.user
  const title = user_progress?.title?.name

  if (size === 'sm') {
    return (
      <div className="flex items-center justify-start gap-4 bg-white rounded-xl py-3 px-5 lg:py-4 lg:px-6">
        <span className="text-base font-bold block w-[15px] text-center text-gray-600">
          {rank}
        </span>
        <div className="aspect-square w-[50px] h-[50px]">
          {user_progress?.avatar && !_.isEmpty(user_progress?.avatar) ? (
            <div className="rounded-full w-[50px] h-[50px] overflow-hidden">
              <Avatar config={user_progress?.avatar} userName={user?.name} />
            </div>
          ) : (
            <Image
              src={_.get(user, 'avatar.file.url', '/placeholders/user.svg')}
              width={200}
              height={200}
              className="rounded-full object-cover object-center"
              alt={user?.name || ''}
            />
          )}
        </div>
        <div className="flex flex-col items-start">
          {title && (
            <span className="text-center font-bold flex text-info text-2xs">
              {title}
            </span>
          )}

          <span className="block text-sm text-center font-bold text-dark">
            {_.startCase(_.toLower(truncateName(user?.name || '', 20)))}{' '}
          </span>
        </div>
        <span className="flex gap-1 items-center text-center text-base text-warning font-semibold ml-auto">
          <StarIcon variant="duotone" size={14} className="text-info" />
          <span className="leading-none block">{points}</span>
        </span>
      </div>
    )
  }

  return (
    <div
      className={`w-full p-2 relative flex flex-col items-center justify-center ${className}`}
      {...rest}
    >
      {rank == 1 ? (
        <AppIcon name="crown" size={16} className="text-warning mb-3" />
      ) : (
        <span
          className={`text-center text-sm font-extrabold ${
            whiteRanking ? 'text-white' : 'text-gray-600'
          } block w-full`}
        >
          {rank}
        </span>
      )}
      {rank == 2 && (
        <AppIcon
          name="caret-up"
          className={whiteRanking ? 'text-white' : 'text-gray-400'}
        />
      )}
      {rank == 3 && (
        <AppIcon  name="caret-down"
          style={{ color: whiteRanking ? '#fff' : '#9B7A01' }}
         />
      )}
      <div
        className={`aspect-square max-w-[175px] ${rank == 1 ? 'mb-4' : 'mb-2'}`}
      >
        {user_progress?.avatar && !_.isEmpty(user_progress?.avatar) ? (
          <div className="rounded-full border border-5 border-white bg-white shadow shadow-sm overflow-hidden">
            <Avatar config={user_progress?.avatar} userName={user?.name} />
          </div>
        ) : (
          <Image
            src={_.get(user, 'avatar.file.url', '/placeholders/user.svg')}
            width={200}
            height={200}
            className="w-full rounded-full border border-4 border-white bg-white shadow shadow-sm object-cover object-center"
            alt={user?.name || ''}
            style={{
              transform: rank === 1 ? 'scale(1)' : 'scale(0.9)'
            }}
          />
        )}
      </div>
      <div className="bg-white rounded px-5 pt-4 pb-3 border-b border-2 border-gray-200 flex items-end justify-between min-w-[225px] gap-3 min-h-[50px]">
        <div className="flex flex-col items-start grow">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold block text-left text-gray-600">
              {rank}
            </span>
            {title && (
              <>
                <span className="text-gray-300 text-2xs">|</span>
                <span className="font-bold flex text-info text-2xs">{title}</span>
              </>
            )}
          </div>
          <span className="block font-bold text-dark text-sm">
            {_.startCase(_.toLower(truncateName(user?.name || '', 20)))}
          </span>
        </div>
        <span className="flex gap-1 items-center justify-center text-center text-warning font-semibold text-base pb-2">
          <StarIcon variant="duotone" size={16} className="text-info" />
          <span className="block leading-none text-base">{points}</span>
        </span>
      </div>
    </div>
  )
}
